__webpack_require__.p = "/mahjong-bti/";